import { FEE_CODE_MAP, PAYMODE_CODE_MAP, PAYPOSY_CODE_MAP } from '@/store/dict/rentPlanDict'

/*
  收款方式
  1  年付
  2  半年一付
  3  周付
  4  月付(满月)
  5  月付(自然月)
  6  一次性
  8  三月一付
  9  30天一付
  10 日付
 */

/*
  收款项
  1   租金
  2   押金
  3   管理费
  4   服务费
  13  定金
  14  滞纳金
  15  全款
  16  保证金
  24  首付款
  25  尾款
  100 其他
*/
export default function config() {
  // 根据收款项展示不同表单项
  const formItemList = [
    {
      code: 1,
      name: '租金',
      showFormItem: {
        startStopDate: true,
        payMode: true,
        dailyRule: true,
        lastPeriodRule: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
        amountAccuracy: true,
      },
      popoverConfig: {
        startStopDate: '将根据“收款起止日期”进行各款项周期的应收拆分',
        payMode: `<span>
        1、月付（自然月）：第一期不足一个月先生成一期应收账款，后面按自然月生成应收账款，比如合同开始时间2019.8.25，那么<br>
          &nbsp &nbsp &nbsp第一期：2019.8.25-2019.8.31<br>
          &nbsp &nbsp &nbsp第二期：2019.9.1-2019-9.30<br>
          &nbsp &nbsp &nbsp ...<br>
        2、月付（满月）：应收账款按照整月生成，比如合同开始时间2019.8.25，那么<br>
          &nbsp &nbsp &nbsp第一期：2019.8.25 - 2019.9.24<br>
          &nbsp &nbsp &nbsp第二期：2019.9.25 - 2019.10.24<br>
          &nbsp &nbsp &nbsp ...<br>
        3、周付：应收账款每7天为一期，按指定星期付款，如缴款日为周一，则每周一为缴款日<br>
        4、日付：应收账款每日为一期，缴款日为当天<br>
        5、一次性：生成一条应收账款，按指定日期付款<br>
        </span>
        `,
        dailyRule: `<span>
          1、当月自然天数计算：日租金=每期租金/当月自然天数<br>
          2、每月30天计算：日租金=每期租金/30天<br>
          3、首期租金=日租金*首期租赁天数<br>
        </span>`,
        lastPeriodRule: `<span>
          以不足月日租金规则计算每日租金，不足月租金金额=每日租金 x 尾期天数
        </span>`,
        amount: `<span>
          1、收款方式为月付（自然月）或月付（满月）时，支持分月按阶梯进行配置，对不同租赁期间设置不同的收款金额。<br>
          2、款项周期金额的计算，支持两种模式：<br>
            &nbsp &nbsp &nbsp1）每期总金额：每个收款的款项周期内的应收总金额。<br>
            &nbsp &nbsp &nbsp2）日租金x每期自然天数：支持填写日租金，按日租金 x  每个收款的款项周期内自然天天数，计算每期应收。<br>
        </span>`,
        payDay: `<span>
          缴款日为当期应收的最晚缴纳时间，超期时将计算为逾期。<br>
          1、收款方式为“月付(自然月)”或“月付(满月)”：可以选择当期或下期的某个日期。注意，如果缴款日在某款项周期内不存在时，该周期内的应收单的缴款日，会自动设为该款项周期起始日期，可以在下一步中手动进行调整。<br>
          2、收款方式为“周付”：可以选择当期或下期中的具体日期。<br>
          3、收款方式为“一次性”：可以选择一个指定日期。<br>
        </span>`,
        advancePayment: `<span>
          按配置生成发车前需要收款款项的应收单<br>
          1、收取首期：当款项周期为多期时，可以选择在发车前只收取首期的款项金额。<br>
          2、发车前不收：发车前无需收款。<br>
          3、收取全部：发车前需要收齐所有款项周期下的总金额。<br>
        </span>`,
        amountAccuracy: `<span>
          配置支付计划中，除尾期外的各款项周期内应付金额的保留位数。<br>
          注：尾期金额=收款起止日期内的应收总金额 - 其他所有期的应收金额总和<br>
            &nbsp &nbsp &nbsp● 金额取整：保留到整数位。<br>
            &nbsp &nbsp &nbsp● 金额保留两位小数：保留到小数点后两位<br>
        </span>`,
      },
    },
    {
      code: 2,
      name: '押金',
      showFormItem: {
        payMode: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
      },
      popoverConfig: {
        payMode: `<span>
        1、月付（自然月）：第一期不足一个月先生成一期应收账款，后面按自然月生成应收账款，比如合同开始时间2019.8.25，那么<br>
          &nbsp &nbsp &nbsp第一期：2019.8.25-2019.8.31<br>
          &nbsp &nbsp &nbsp第二期：2019.9.1-2019-9.30<br>
          &nbsp &nbsp &nbsp ...<br>
        2、月付（满月）：应收账款按照整月生成，比如合同开始时间2019.8.25，那么<br>
          &nbsp &nbsp &nbsp第一期：2019.8.25 - 2019.9.24<br>
          &nbsp &nbsp &nbsp第二期：2019.9.25 - 2019.10.24<br>
          &nbsp &nbsp &nbsp ...<br>
        3、周付：应收账款每7天为一期，按指定星期付款，如缴款日为周一，则每周一为缴款日<br>
        4、一次性：生成一条应收账款，按指定日期付款<br>
        </span>
        `,
        amount: `<span>
          每期总金额：每个收款的款项周期内的应收总金额。当收款方式为“一次性”时，为全部应收总金额。`,
        payDay: `<span>
          缴款日为当期应收的最晚缴纳时间，超期时将计算为逾期。<br>
          1、收款方式为“月付(自然月)”或“月付(满月)”：可以选择当期或下期的某个日期。注意，如果缴款日在某款项周期内不存在时，该周期内的应收单的缴款日，会自动设为该款项周期起始日期，可以在下一步中手动进行调整。<br>
          2、收款方式为“周付”：可以选择当期或下期中的具体日期。<br>
          3、收款方式为“一次性”：缴款日为租赁订单的收款起始日。<br>
        </span>`,
        advancePayment: `<span>
          按配置生成发车前需要收款款项的应收单<br>
          1、收取首期：当款项周期为多期时，可以选择在发车前只收取首期的款项金额。<br>
          2、收取全部：发车前需要收齐所有款项周期下的总金额。<br>
        </span>`,
      },
    },
    {
      code: 3,
      name: '管理费',
      showFormItem: {
        payMode: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
      },
      popoverConfig: {
        payMode: `<span>
        1、月付（自然月）：第一期不足一个月先生成一期应收账款，后面按自然月生成应收账款，比如合同开始时间2019.8.25，那么<br>
          &nbsp &nbsp &nbsp第一期：2019.8.25-2019.8.31<br>
          &nbsp &nbsp &nbsp第二期：2019.9.1-2019-9.30<br>
          &nbsp &nbsp &nbsp ...<br>
        2、月付（满月）：应收账款按照整月生成，比如合同开始时间2019.8.25，那么<br>
          &nbsp &nbsp &nbsp第一期：2019.8.25 - 2019.9.24<br>
          &nbsp &nbsp &nbsp第二期：2019.9.25 - 2019.10.24<br>
          &nbsp &nbsp &nbsp ...<br>
        3、周付：应收账款每7天为一期，按指定星期付款，如缴款日为周一，则每周一为缴款日<br>
        4、一次性：生成一条应收账款，按指定日期付款<br>
        </span>
        `,
        amount: `<span>
          每期总金额：每个收款的款项周期内的应收总金额。当收款方式为“一次性”时，为全部应收总金额。`,
        payDay: `<span>
          缴款日为当期应收的最晚缴纳时间，超期时将计算为逾期。<br>
          1、收款方式为“月付(自然月)”或“月付(满月)”：可以选择当期或下期的某个日期。注意，如果缴款日在某款项周期内不存在时，该周期内的应收单的缴款日，会自动设为该款项周期起始日期，可以在下一步中手动进行调整。<br>
          2、收款方式为“周付”：可以选择当期或下期中的具体日期。<br>
          3、收款方式为“一次性”：缴款日为租赁订单的收款起始日。<br>
        </span>`,
        advancePayment: `<span>
          按配置生成发车前需要收款款项的应收单<br>
          1、收取首期：当款项周期为多期时，可以选择在发车前只收取首期的款项金额。<br>
          2、收取全部：发车前需要收齐所有款项周期下的总金额。<br>
        </span>`,
      },
    },
    {
      code: 4,
      name: '服务费',
      showFormItem: {
        payMode: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
      },
      popoverConfig: {
        payMode: `<span>
        1、月付（自然月）：第一期不足一个月先生成一期应收账款，后面按自然月生成应收账款，比如合同开始时间2019.8.25，那么<br>
          &nbsp &nbsp &nbsp第一期：2019.8.25-2019.8.31<br>
          &nbsp &nbsp &nbsp第二期：2019.9.1-2019-9.30<br>
          &nbsp &nbsp &nbsp ...<br>
        2、月付（满月）：应收账款按照整月生成，比如合同开始时间2019.8.25，那么<br>
          &nbsp &nbsp &nbsp第一期：2019.8.25 - 2019.9.24<br>
          &nbsp &nbsp &nbsp第二期：2019.9.25 - 2019.10.24<br>
          &nbsp &nbsp &nbsp ...<br>
        3、周付：应收账款每7天为一期，按指定星期付款，如缴款日为周一，则每周一为缴款日<br>
        4、一次性：生成一条应收账款，按指定日期付款<br>
        </span>
        `,
        amount: `<span>
          每期总金额：每个收款的款项周期内的应收总金额。当收款方式为“一次性”时，为全部应收总金额。`,
        payDay: `<span>
          缴款日为当期应收的最晚缴纳时间，超期时将计算为逾期。<br>
          1、收款方式为“月付(自然月)”或“月付(满月)”：可以选择当期或下期的某个日期。注意，如果缴款日在某款项周期内不存在时，该周期内的应收单的缴款日，会自动设为该款项周期起始日期，可以在下一步中手动进行调整。<br>
          2、收款方式为“周付”：可以选择当期或下期中的具体日期。<br>
          3、收款方式为“一次性”：缴款日为租赁订单的收款起始日。<br>
        </span>`,
        advancePayment: `<span>
          按配置生成发车前需要收款款项的应收单<br>
          1、收取首期：当款项周期为多期时，可以选择在发车前只收取首期的款项金额。<br>
          2、收取全部：发车前需要收齐所有款项周期下的总金额。<br>
        </span>`,
      },
    },
    {
      code: 24,
      name: '首付款',
      showFormItem: {
        payMode: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
      },
      popoverConfig: {
        payMode: '<span>生成一条应收账款，按指定日期付款。</span>',
        amount: '<span>当收款方式为“一次性”时，为全部应收总金额。</span>',
        payDay: '<span>缴款日为租赁订单的收款起始日。</span>',
        advancePayment: '<span>发车前需要收齐所有款项周期下的总金额。</span>',
      },
    },
    {
      code: 13,
      name: '定金',
      showFormItem: {
        payMode: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
      },
      popoverConfig: {
        payMode: '<span>生成一条应收账款，按指定日期付款。</span>',
        amount: '<span>当收款方式为“一次性”时，为全部应收总金额。</span>',
        payDay: '<span>缴款日为租赁订单的收款起始日。</span>',
        advancePayment: '<span>发车前需要收齐所有款项周期下的总金额。</span>',
      },
    },
    {
      code: 14,
      name: '滞纳金',
      showFormItem: {
        payMode: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
      },
      // 新滞纳金表单item项
      newShowFormItem: {
        lateFeeProportion: true,
        interestFreeDays: true,
      },
      popoverConfig: {
        payMode: '<span>生成一条应收账款，按指定日期付款。</span>',
        amount: '<span>当收款方式为“一次性”时，为全部应收总金额。</span>',
        payDay: '<span>缴款日为租赁订单的收款起始日。</span>',
        advancePayment: '<span>发车前无需收款。</span>',
        lateFeeProportion: '<span>逾期缴款次日将按此比例收取欠款滞纳金，支持小数点后两位小数，向上取整</span>',
        interestFreeDays: '<span>逾期缴款免缴滞纳金的天数，可输入0-365之间的数字</span>',
      },
    },
    {
      code: 15,
      name: '全款',
      showFormItem: {
        payMode: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
      },
      popoverConfig: {
        payMode: '<span>生成一条应收账款，按指定日期付款。</span>',
        amount: '<span>当收款方式为“一次性”时，为全部应收总金额。</span>',
        payDay: '<span>缴款日为租赁订单的收款起始日。</span>',
        advancePayment: '<span>发车前需要收齐所有款项周期下的总金额。</span>',
      },
    },
    {
      code: 16,
      name: '保证金',
      showFormItem: {
        payMode: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
      },
      popoverConfig: {
        payMode: '<span>生成一条应收账款，按指定日期付款。</span>',
        amount: '<span>当收款方式为“一次性”时，为全部应收总金额。</span>',
        payDay: '<span>缴款日为租赁订单的收款起始日。</span>',
        advancePayment: '<span>发车前需要收齐所有款项周期下的总金额。</span>',
      },
    },
    {
      code: 25,
      name: '尾款',
      showFormItem: {
        payMode: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
      },
      popoverConfig: {
        payMode: '<span>生成一条应收账款，按指定日期付款。</span>',
        amount: '<span>当收款方式为“一次性”时，为全部应收总金额。</span>',
        payDay: '<span>缴款日为租赁订单的收款起始日。</span>',
        advancePayment: '<span>发车前无需收款。</span>',
      },
    },
    {
      code: 100,
      name: '其他',
      showFormItem: {
        payMode: true,
        payPlanType: true,
        payDay: true,
        advancePayment: true,
        amountAccuracy: true,
      },
      popoverConfig: {
        payMode: `<span>
        1、月付（自然月）：第一期不足一个月先生成一期应收账款，后面按自然月生成应收账款，比如合同开始时间2019.8.25，那么<br>
          &nbsp &nbsp &nbsp第一期：2019.8.25-2019.8.31<br>
          &nbsp &nbsp &nbsp第二期：2019.9.1-2019-9.30<br>
          &nbsp &nbsp &nbsp ...<br>
        2、月付（满月）：应收账款按照整月生成，比如合同开始时间2019.8.25，那么<br>
          &nbsp &nbsp &nbsp第一期：2019.8.25 - 2019.9.24<br>
          &nbsp &nbsp &nbsp第二期：2019.9.25 - 2019.10.24<br>
          &nbsp &nbsp &nbsp ...<br>
        3、周付：应收账款每7天为一期，按指定星期付款，如缴款日为周一，则每周一为缴款日<br>
        4、一次性：生成一条应收账款，按指定日期付款<br>
        </span>
        `,
        amount: '<span>每期总金额：每个收款的款项周期内的应收总金额。当收款方式为“一次性”时，为全部应收总金额。</span>',
        payDay: `<span>
          缴款日为当期应收的最晚缴纳时间，超期时将计算为逾期。<br>
          1、收款方式为“月付(自然月)”或“月付(满月)”：可以选择当期或下期的某个日期。注意，如果缴款日在某款项周期内不存在时，该周期内的应收单的缴款日，会自动设为该款项周期起始日期，可以在下一步中手动进行调整。<br>
          2、收款方式为“周付”：可以选择当期或下期中的具体日期。<br>
          3、收款方式为“一次性”：可以选择一个指定日期。<br>
        </span>`,
        advancePayment: `<span>
          按配置生成发车前需要收款款项的应收单<br>
          1、收取首期：当款项周期为多期时，可以选择在发车前只收取首期的款项金额。<br>
          2、发车前不收：发车前无需收款。<br>
          3、收取全部：发车前需要收齐所有款项周期下的总金额。<br>
        </span>`,
        amountAccuracy: `<span>
          配置支付计划中，除尾期外的各款项周期内应付金额的保留位数。<br>
          注：尾期金额=收款起止日期内的应收总金额 - 其他所有期的应收金额总和<br>
            &nbsp &nbsp &nbsp● 金额取整：保留到整数位。<br>
            &nbsp &nbsp &nbsp● 金额保留两位小数：保留到小数点后两位<br>
        </span>`,
      },
    },
  ]

  const paymentMethodsList = [
    {
      code: 1,
      list: [
        {
          value: 5,
          label: '月付（自然月）',
        },
        {
          value: 4,
          label: '月付（满月）',
        },
        {
          value: 3,
          label: '周付',
        },
        {
          value: 10,
          label: '日付',
        },
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
    {
      code: 2,
      list: [
        {
          value: 5,
          label: '月付（自然月）',
        },
        {
          value: 4,
          label: '月付（满月）',
        },
        {
          value: 3,
          label: '周付',
        },
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
    {
      code: 3,
      list: [
        {
          value: 5,
          label: '月付（自然月）',
        },
        {
          value: 4,
          label: '月付（满月）',
        },
        {
          value: 3,
          label: '周付',
        },
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
    {
      code: 4,
      list: [
        {
          value: 5,
          label: '月付（自然月）',
        },
        {
          value: 4,
          label: '月付（满月）',
        },
        {
          value: 3,
          label: '周付',
        },
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
    {
      code: 13,
      list: [
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
    {
      code: 14,
      list: [
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
    {
      code: 15,
      list: [
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
    {
      code: 16,
      list: [
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
    {
      code: 24,
      list: [
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
    {
      code: 25,
      list: [
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
    {
      code: 100,
      list: [
        {
          value: 5,
          label: '月付（自然月）',
        },
        {
          value: 4,
          label: '月付（满月）',
        },
        {
          value: 3,
          label: '周付',
        },
        {
          value: 6,
          label: '一次性',
        },
      ],
    },
  ]

  function validatorPayDay(rule, value, callback) {
    const min = 1
    const max = 31
    const errorText = '请输入 1-31 之间的数字'
    const { fundType } = this.configData
    const { payMode, payPost } = this.formData

    if (
      (
        fundType === FEE_CODE_MAP.ZU_JIN ||
        fundType === FEE_CODE_MAP.YA_JIN ||
        fundType === FEE_CODE_MAP.GUAN_LI_FEE ||
        fundType === FEE_CODE_MAP.FU_WU_FEE ||
        fundType === FEE_CODE_MAP.OTHERS
      ) &&
      payMode !== PAYMODE_CODE_MAP.DAY
    ) {
      if (this.formData.payPost === '') {
        callback(new Error('请确认缴款日'))
      }
    }

    // 新增(编辑)租赁方案模板时，如果收款方式不是“日付”，且缴款日不是“订单收款起始日”或“自定义”，则payDay不能为空
    if (this.isAddScheme && payMode !== PAYMODE_CODE_MAP.DAY && ![PAYPOSY_CODE_MAP.RECEIPT_START_DATE, PAYPOSY_CODE_MAP.CUSTOM].includes(payPost) && !value) {
      callback(new Error('请确认缴款日'))
    } else if (!this.isAddScheme && payMode !== PAYMODE_CODE_MAP.DAY && !value) {
      // 使用租赁方案模板时，如果收款方式不是“日付”，则payDay不能为空
      callback(new Error('请确认缴款日'))
    }

    if (isNaN(value) || (value >= min && value <= max) || value === '') {
      callback()
    }
    callback(new Error(errorText))
  }

  function validatorInterestFreeDays(rule, value, callback) {
    if (rule.required === true) {
      if (value === '') {
        return callback(new Error('请输入滞纳金免息天数'))
      }
    }
    const min = 0
    const max = 365
    if ((!isNaN(value) && (value >= min && value <= max)) || value === '') {
      return callback()
    }
    callback(new Error('请输入0-365之间的数字'))
  }

  const configRules = {
    payMode: [
      {
        required: true,
        message: '请选择收款方式',
        trigger: ['blur'],
      },
    ],
    dailyRule: [
      {
        required: true,
        message: '请选择不足月日租金规则',
        trigger: ['change', 'blur'],
      },
    ],
    lastPeriodRule: [
      {
        required: true,
        message: '请选择尾期租金规则',
        trigger: ['change', 'blur'],
      },
    ],
    payPlanType: [
      {
        required: true,
        message: '收款金额不能为空',
      },
    ],
    payDay: [
      {
        required: true,
        validator: validatorPayDay.bind(this),
        trigger: ['blur'],
      },
    ],
    advancePayment: [
      {
        required: true,
        message: '请选择发车前收款',
        trigger: ['blur'],
      },
    ],
    amountAccuracy: [
      {
        required: true,
        message: '请选择收款金额保留位数',
        trigger: ['blur'],
      },
    ],
    lateFeeProportion: [
      {
        required: true,
        message: '请输入滞纳金收取比例',
        trigger: ['blur'],
      },
    ],
    interestFreeDays: [
      {
        required: true,
        validator: validatorInterestFreeDays.bind(this),
        trigger: ['blur'],
      },
    ],
  }

  return {
    configRules,
    paymentMethodsList,
    formItemList,
  }
}
